'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "filterFamily", "getFamilyValueResolver", "getFilterFamilyObjectName", "getObjectPropertyLabel", "getInputComponent", "getOperatorLabel", "getOperators", "getPlaceholder", "getReferencedObjectType", "getSpecialOptionsForReferenceType", "isXoEnabled", "value", "onChange", "initialValue", "nullIssueRelatedState", "updateNullIssueRelatedState", "isFiscalYearEnabled", "getIsUngated", "isNotUsingTimePoints", "isFilterIncompatible"];
import * as Operators from 'customer-data-filters/filterQueryFormat/operator/Operators';
import { DATE, NUMBER } from 'customer-data-objects/property/PropertyTypes';
import { OrderedSet } from 'immutable';
import DSFieldRecord from 'customer-data-filters/filterQueryFormat/DSFieldRecord/DSFieldRecord';
import FilterOperatorErrorRecord from 'customer-data-filters/filterQueryFormat/FilterOperatorErrorRecord';
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import FilterOperatorInput from 'customer-data-filters/components/operator/FilterOperatorInput';
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import FilterType from '../propTypes/FilterType';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import HR from 'UIComponents/elements/HR';
import NullRelatedState from '../propTypes/NullRelatedState';
import PropTypes from 'prop-types';
import { Fragment, Component } from 'react';
import Small from 'UIComponents/elements/Small';
import { syntheticEvent as SyntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import always from 'transmute/always';
import getIn from 'transmute/getIn';
import partial from 'transmute/partial';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const _getDateRefinementOperators = ctor => {
  const baseSet = OrderedSet([Operators.Any, Operators.LessOrEqual, Operators.GreaterOrEqual, Operators.InRange]);
  if (ctor.isRefinableExtra) {
    return baseSet.concat(OrderedSet([Operators.LessThanRolling, Operators.GreaterThanRolling]));
  } else if (ctor.isRefinable) {
    return baseSet;
  }
  return OrderedSet();
};
const numberOfTimesRefinementOperators = OrderedSet([Operators.Any, Operators.Less, Operators.Equal, Operators.Greater]);
const _getRefinementType = value => {
  if (!value || !value.refinement) {
    return 'NONE';
  }
  const dateRefinemntOperators = _getDateRefinementOperators(value.constructor);
  const hasDateRefinement = dateRefinemntOperators.some(operatorConstructor => operatorConstructor === value.refinement.constructor && value.refinement.constructor !== Operators.Any);
  const hasNumberOfTimesRefinement = numberOfTimesRefinementOperators.some(operatorConstructor => operatorConstructor === value.refinement.constructor && value.refinement.constructor !== Operators.Any);
  if (hasDateRefinement) {
    return DATE;
  } else if (hasNumberOfTimesRefinement) {
    return NUMBER;
  }
  return 'NONE';
};
export default class FilterOperatorRefinableInput extends Component {
  constructor(props) {
    super(props);
    this.handleChangeRefinement = (type, evt) => {
      const {
        target: {
          value: v
        }
      } = evt;
      const {
        onChange,
        value
      } = this.props;
      if (this.previousType !== 'NONE' && this.previousType !== type) {
        this.setState({
          accordionOpenStatus: {
            [DATE]: true,
            [NUMBER]: true
          }
        });
      }
      this.previousType = type;
      const nextValue = value.set('refinement', v).setIn(['refinement', 'field', 'type'], type);
      onChange(SyntheticEvent(nextValue));
    };
    this.handleOpenChange = type => {
      this.setState(prevState => ({
        accordionOpenStatus: Object.assign({}, prevState.accordionOpenStatus, {
          [type]: !prevState.accordionOpenStatus[type]
        })
      }));
    };
    const initialRefinementType = _getRefinementType(props.value);
    this.state = {
      accordionOpenStatus: {
        [DATE]: initialRefinementType === DATE,
        [NUMBER]: initialRefinementType === NUMBER
      }
    };
    this.previousType = initialRefinementType;
  }
  getRefinementValueMinusOtherTypes(desiredType, value) {
    return getIn(['refinement', 'field', 'type'], value) === desiredType ? value.refinement : Operators.Any.of(DSFieldRecord({
      refinement: true,
      type: desiredType
    }));
  }
  renderSection(type, operators, title, error) {
    const {
      currencyCode,
      filterFamily,
      getDefaultTimezone,
      getFamilyValueResolver,
      getInputComponent,
      getIsUngated,
      getOperatorLabel,
      getPlaceholder,
      getReferencedObjectType,
      getSpecialOptionsForReferenceType,
      isFiscalYearEnabled,
      isNotUsingTimePoints,
      isRollingDateOffsetInputEnabled,
      isXoEnabled,
      value,
      getFilterFamilyObjectName,
      getObjectPropertyLabel,
      filterBranch,
      handleIncludeObjectsWithNoAssociatedObjectsChange
    } = this.props;
    const {
      accordionOpenStatus
    } = this.state;
    return /*#__PURE__*/_jsx(UIAccordionItem, {
      className: "m-top-2 p-left-1",
      onOpenChange: partial(this.handleOpenChange, type),
      open: accordionOpenStatus[type],
      title: title,
      children: /*#__PURE__*/_jsx(FilterOperatorInput, {
        currencyCode: currencyCode,
        error: error,
        filterBranch: filterBranch,
        filterFamily: filterFamily,
        getDefaultTimezone: getDefaultTimezone,
        getFamilyValueResolver: getFamilyValueResolver,
        getFilterFamilyObjectName: getFilterFamilyObjectName,
        getInputComponent: getInputComponent,
        getIsUngated: getIsUngated,
        getObjectPropertyLabel: getObjectPropertyLabel,
        getOperatorLabel: getOperatorLabel,
        getOperators: always(operators),
        getPlaceholder: getPlaceholder,
        getReferencedObjectType: getReferencedObjectType,
        getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
        handleIncludeObjectsWithNoAssociatedObjectsChange: handleIncludeObjectsWithNoAssociatedObjectsChange,
        isFiscalYearEnabled: isFiscalYearEnabled,
        isNotUsingTimePoints: isNotUsingTimePoints,
        isRollingDateOffsetInputEnabled: isRollingDateOffsetInputEnabled,
        isXoEnabled: isXoEnabled,
        onChange: partial(this.handleChangeRefinement, type),
        showIncludeUnknownValues: false,
        value: this.getRefinementValueMinusOtherTypes(type, value)
      })
    });
  }
  render() {
    const _this$props = this.props,
      {
        error,
        filterFamily,
        getFamilyValueResolver,
        getFilterFamilyObjectName,
        getObjectPropertyLabel,
        getInputComponent,
        getOperatorLabel,
        getOperators,
        getPlaceholder,
        getReferencedObjectType,
        getSpecialOptionsForReferenceType,
        isXoEnabled,
        value,
        onChange,
        initialValue,
        nullIssueRelatedState,
        updateNullIssueRelatedState,
        isFiscalYearEnabled,
        getIsUngated,
        isNotUsingTimePoints,
        isFilterIncompatible = false
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const errorOpts = error.get('opts');
    const errorMessage = error.get('message');
    const isError = errorOpts && errorOpts.preventDefault === true ? FilterOperatorErrorRecord({
      message: errorMessage,
      opts: errorOpts
    }) : error;
    const refinementError = errorOpts && errorOpts.isRefinement === true ? error : FilterOperatorErrorRecord({
      message: errorMessage,
      opts: errorOpts
    });
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FilterOperatorInput, Object.assign({}, rest, {
        error: isError,
        filterFamily: filterFamily,
        getFamilyValueResolver: getFamilyValueResolver,
        getFilterFamilyObjectName: getFilterFamilyObjectName,
        getInputComponent: getInputComponent,
        getIsUngated: getIsUngated,
        getObjectPropertyLabel: getObjectPropertyLabel,
        getOperatorLabel: getOperatorLabel,
        getOperators: getOperators,
        getPlaceholder: getPlaceholder,
        getReferencedObjectType: getReferencedObjectType,
        getSpecialOptionsForReferenceType: getSpecialOptionsForReferenceType,
        initialValue: initialValue,
        isFilterIncompatible: isFilterIncompatible,
        isFiscalYearEnabled: isFiscalYearEnabled,
        isNotUsingTimePoints: isNotUsingTimePoints,
        isXoEnabled: isXoEnabled,
        nullIssueRelatedState: nullIssueRelatedState,
        onChange: onChange,
        updateNullIssueRelatedState: updateNullIssueRelatedState,
        value: value
      })), isXoEnabled && value.constructor.isRefinable && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(H5, {
          className: "display-block m-bottom-2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterOperatorInput.refineFilter"
          })
        }), /*#__PURE__*/_jsx(Small, {
          className: "display-block m-bottom-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customerDataFilters.FilterOperatorInput.refineFilterHelp"
          })
        }), this.renderSection(DATE, _getDateRefinementOperators(value.constructor), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFilters.FilterOperatorInput.refineByDate"
        }), refinementError)]
      }), isXoEnabled && value.constructor.isRefinableExtra && this.renderSection(NUMBER, OrderedSet([Operators.Any, Operators.Less, Operators.Equal, Operators.Greater]), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFilters.FilterOperatorInput.refineByOccurrenceCount"
      }), refinementError)]
    });
  }
}
FilterOperatorRefinableInput.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  error: FilterOperatorErrorType.isRequired,
  filterBranch: FilterType,
  filterFamily: PropTypes.string.isRequired,
  getDefaultTimezone: PropTypes.func.isRequired,
  getFamilyValueResolver: PropTypes.func.isRequired,
  getFilterFamilyObjectName: PropTypes.func.isRequired,
  getInputComponent: PropTypes.func.isRequired,
  getIsUngated: PropTypes.func.isRequired,
  getObjectPropertyLabel: PropTypes.func.isRequired,
  getOperatorLabel: PropTypes.func.isRequired,
  getOperators: PropTypes.func.isRequired,
  getPlaceholder: PropTypes.func.isRequired,
  getReferencedObjectType: PropTypes.func.isRequired,
  getSpecialOptionsForReferenceType: PropTypes.func.isRequired,
  handleIncludeObjectsWithNoAssociatedObjectsChange: PropTypes.func,
  initialValue: FilterOperatorType,
  isFilterIncompatible: PropTypes.bool,
  isFiscalYearEnabled: PropTypes.bool.isRequired,
  isNotUsingTimePoints: PropTypes.bool,
  isRollingDateOffsetInputEnabled: PropTypes.bool,
  isXoEnabled: PropTypes.bool,
  nullIssueRelatedState: NullRelatedState,
  onChange: PropTypes.func.isRequired,
  showIncludeUnknownValues: PropTypes.bool.isRequired,
  updateNullIssueRelatedState: PropTypes.func,
  value: FilterOperatorType.isRequired
};